export enum DnbHeader {
  IdempotencyKey = 'X-DNBAPI-Idempotency-Key',
}

export function getDnbHeaderValue(header: DnbHeader) {
  if (header === DnbHeader.IdempotencyKey) return uuid();
}

function uuid() {
  return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (placeholder) {
      const random = (Math.random() * 16) | 0;
      const value = placeholder === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    }
  );
}
